var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkBtnIconLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26.8556,
    height: 24.9112,
    rx: 4.67085,
    fill: "#EEEEF0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 26.8556,
    height: 24.9112,
    rx: 4.67085,
    stroke: "#6E6E7C",
    strokeWidth: 0.778475
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.36342 12.3232C9.89334 9.95061 11.9974 8.26433 14.4257 8.26612C14.8056 8.26564 15.1842 8.30844 15.5544 8.39369C16.9029 8.69053 18.0769 9.51464 18.8154 10.6827C19.5538 11.8507 19.7954 13.2658 19.4863 14.6131C19.4594 14.7625 19.3513 14.8844 19.2063 14.9288C19.0613 14.9733 18.9036 14.9329 18.7977 14.8242C18.6918 14.7155 18.6555 14.5566 18.7036 14.4126C19.1892 12.241 17.9653 10.0512 15.8627 9.32972C13.76 8.60822 11.4518 9.58597 10.5049 11.5993C9.55793 13.6126 10.2754 16.0169 12.1703 17.1801C14.0653 18.3433 16.5308 17.893 17.8935 16.1349C18.0399 15.9992 18.2632 15.9904 18.4197 16.1142C18.5763 16.238 18.6195 16.4575 18.5215 16.6315C17.0355 18.5544 14.4154 19.1867 12.2176 18.1527C10.0198 17.1188 8.8335 14.6959 9.36342 12.3232ZM14.4967 14.7106C14.4073 14.5222 14.4752 14.2968 14.6535 14.1892L14.9584 14.0389L15.4681 12.4077L13.8753 12.9089L13.1472 15.2372C13.0817 15.4484 12.8577 15.5667 12.6466 15.5014C12.5442 15.47 12.4587 15.3988 12.4091 15.3038C12.3595 15.2088 12.35 15.0978 12.3827 14.9957L13.1745 12.4624C13.2155 12.3383 13.3138 12.2416 13.4385 12.2027L15.9687 11.4099C16.0452 11.3824 16.1289 11.3824 16.2054 11.4099C16.3074 11.4403 16.393 11.5106 16.4426 11.6049C16.4923 11.6992 16.5019 11.8096 16.4693 11.9111L15.6593 14.4489C15.627 14.5542 15.553 14.6415 15.4545 14.6904L14.9994 14.9182C14.8034 14.9887 14.586 14.8989 14.4967 14.7106Z",
    fill: "#141518"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkBtnIconLight);
export default __webpack_public_path__ + "static/media/LinkBtnIcon_light.dcded580b8e1aff6ef106b9002d06b20.svg";
export { ForwardRef as ReactComponent };